import addARIACurrent from './module/addARIACurrent';
import {fadeToggle} from './module/fade';
import {slideToggle} from './module/slide';
import pcAddIshover from './module/pcAddIshover';
import gnavToggle from './module/gnavToggle';
import smoothScroll from './module/smoothScroll';
import maqruee from 'vanilla-marquee';

(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
    addARIACurrent();
    slideToggle();
    pcAddIshover();
    smoothScroll();

    const mqEl = document.getElementById('js-marquee');
    if(mqEl) {
      const qW = mqEl.offsetWidth;
      new maqruee(mqEl, {
        duration: qW * 10
      });
    }

    const unitEl = document.querySelectorAll('.js-fade-unit');
    [].forEach.call(unitEl, function (el) {
      const btn = el.querySelector('.js-fade-switch')
      const elTarget = el.querySelector('.js-fade-target');
      btn.addEventListener('click', function(e) {
        fadeToggle(e.currentTarget, elTarget);
      })
    });

		const sunitEl = document.querySelectorAll('.js-slide-unit');

		[].forEach.call(sunitEl, function (el) {
			const sbtn = el.querySelector('.js-slide-switch')
			const selTarget = el.querySelector('.js-slide-target');
			sbtn.addEventListener('click', function(e) {
        sbtn.querySelector('.c-icon').classList.toggle('is-active')
				slideToggle(el.currentTarget, selTarget);
			});
		});
  });

  window.addEventListener('load', function(e) {
    // addScrollIntoView();
  });

  gnavToggle();
})();
